import type { RouteRecordRaw } from 'vue-router'

import { DEFAULT_LAYOUT } from '@/router/constant'

const bulkUploadFiles: RouteRecordRaw = {
  path: '/bulk-upload-files',
  component: DEFAULT_LAYOUT,

  children: [
    {
      path: '',
      name: 'BulkUploadFiles',

      component: () =>
        import(
          /** webpackChunkName "initialize" */ '@/views/bulk-upload-files/IndexView.vue'
        ),

      meta: { title: 'ファイル一括アップロード', requiresAuth: true },
    },
  ],
}

export default bulkUploadFiles
